import {SlidersIcon} from '@primer/octicons-react'
import {ActionList, ActionMenu, IconButton} from '@primer/react'
import {sendEvent} from '@github-ui/hydro-analytics'
import {useStoredTimelineVerbosity, type TimelineVerbosity} from '../session-logs/ahp/timeline-verbosity'

const OPTIONS: ReadonlyArray<{value: TimelineVerbosity; label: string; description: string}> = [
  {value: 'minimal', label: 'Minimal', description: 'Hide intermediate steps'},
  {value: 'balanced', label: 'Balanced', description: 'Show key steps'},
  {value: 'detailed', label: 'Detailed', description: 'Show every tool call'},
]

export function TimelineVerbosityControl() {
  const [verbosity, setVerbosity] = useStoredTimelineVerbosity()
  const active = OPTIONS.find(option => option.value === verbosity) ?? OPTIONS[1]
  const label = `Log verbosity: ${active?.label ?? 'Balanced'}`

  const handleSelect = (next: TimelineVerbosity) => {
    if (next === verbosity) return
    setVerbosity(next)
    sendEvent('agent_sessions.task_view', {
      target: 'TIMELINE_VERBOSITY',
      action: 'SELECT',
      verbosity: next,
      previous_verbosity: verbosity,
    })
  }

  return (
    <ActionMenu>
      <ActionMenu.Anchor>
        <IconButton icon={SlidersIcon} variant="default" aria-label={label} />
      </ActionMenu.Anchor>
      <ActionMenu.Overlay align="end">
        <ActionList selectionVariant="single">
          {OPTIONS.map(option => (
            <ActionList.Item
              key={option.value}
              selected={option.value === verbosity}
              onSelect={() => handleSelect(option.value)}
            >
              {option.label}
              <ActionList.Description variant="block">{option.description}</ActionList.Description>
            </ActionList.Item>
          ))}
        </ActionList>
      </ActionMenu.Overlay>
    </ActionMenu>
  )
}
